import React from 'react'

// components
import {
  CCol,
  CFormLabel,
  CDatePicker,
} from '@coreui/react-pro'
import '../../../css/FormDatePicker.css'

const FormDatePicker = ({
  editPage,
  id,
  name,
  colSize,
  className,
  inputLabel,
  feedbackInvalid,
  invalid,
  value,
  handleOnDateChange,
  disabled,
  maxDate,
  minDate,
  withTimePicker = false,
  cleaner = true
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <CFormLabel>
        {inputLabel}
      </CFormLabel>
      <CDatePicker
        locale="en-US" 
        id={id}
        name={name}
        date={value}
        className={feedbackInvalid ? 'date_picker_invalid' : ''}
        onDateChange={(value) => handleOnDateChange(value, name)}
        feedbackInvalid={feedbackInvalid}
        invalid={invalid ? true : false}
        disabled={disabled}
        maxDate={maxDate}
        minDate={minDate}
        timepicker={withTimePicker}
        cleaner={cleaner}
      />
    </CCol>
  )
}

export default FormDatePicker